import { jsx as n, Fragment as v, jsxs as t } from "react/jsx-runtime";
import { useCallback as u, useState as D, useRef as C, useEffect as M } from "react";
import { createPortal as N } from "react-dom";
import e from "./styles.module.less.js";
import { MenuItem as k } from "../menu-item/index.js";
import b from "../close.svg.js";
import L from "../menu-dropdown-wrapper.svg.js";
import T from "../menu-dropdown-wrapper-mobile.svg.js";
import S from "../chevron-right.svg.js";
import { useDisableScroll as E } from "../../../../utils/use-disable-scroll.js";
import { IMAGE_BASE_PATH as A } from "../../../../constants.js";
const x = `${A}/default-area-of-law.webp`, P = (w) => {
  const { language: I, isActive: c, hasShrunk: g, items: l, titleLabel: o, link: p, classNames: a } = w, h = u(() => {
    window.location.href = p;
  }, [I]), [f, d] = D(null), m = C(null), s = u((r) => {
    m.current && clearTimeout(m.current), d(r);
  }, []), i = u(() => {
    m.current = setTimeout(() => {
      d(null);
    }, 300);
  }, []);
  return /* @__PURE__ */ n(
    k,
    {
      label: o ?? "",
      chevronStyle: "rotate",
      hasShrunk: g,
      isActive: c,
      onClick: h,
      classNames: {
        labelContainer: e.menuItemContainer,
        childContainer: e.menuItemDropdown
      },
      children: /* @__PURE__ */ n(v, { children: /* @__PURE__ */ t(
        "div",
        {
          className: `${e.innerWrapper} ${(a == null ? void 0 : a.container) ?? ""}`,
          children: [
            /* @__PURE__ */ n("div", { className: e.dropdownGrid, children: l.map((r, $) => /* @__PURE__ */ t(
              "a",
              {
                className: `${e.menuDropdownItem} ${(a == null ? void 0 : a.itemRow) ?? ""}`,
                href: r.path,
                onMouseEnter: () => s($),
                onMouseLeave: i,
                children: [
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemTitle, children: r.title }),
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemDescription, children: r.description })
                ]
              },
              r.title
            )) }),
            /* @__PURE__ */ n("div", { className: e.dropdownImageWrapper, children: /* @__PURE__ */ t("div", { className: e.areaOfLawImageContainer, children: [
              /* @__PURE__ */ n(L, { className: e.menuDropdownBGIcon }),
              /* @__PURE__ */ n(
                "img",
                {
                  src: x,
                  alt: "default-area-of-law",
                  className: `${e.areaOfLawImage} ${e.defaultImage} ${f === null ? e.imageVisible : e.imageHidden}`
                }
              ),
              l.map((r, $) => r.image ? /* @__PURE__ */ n(
                "img",
                {
                  src: r.image,
                  alt: r.title,
                  className: `${e.areaOfLawImage} ${f === $ ? e.imageVisible : e.imageHidden} ${r.isDefaultStyle ? e.defaultImage : ""}`
                },
                `${r.title}-image`
              ) : null)
            ] }) })
          ]
        }
      ) })
    }
  );
}, V = (w) => {
  const { items: I, titleLabel: c, link: g, iconComponent: l, classNames: o, children: p } = w, [a, h] = D(!1), [f, d] = D(!1);
  E({ isDisabled: a });
  const m = u(() => {
    h(!0);
  }, []), s = u(() => {
    d(!0), setTimeout(() => {
      h(!1), d(!1);
    }, 150);
  }, []);
  return M(() => (window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  }), [s]), /* @__PURE__ */ t(v, { children: [
    /* @__PURE__ */ n("div", { className: e.headingContainer, onClick: m, children: p || (c ? /* @__PURE__ */ t(v, { children: [
      /* @__PURE__ */ n(
        "div",
        {
          className: `${e.mainMenuLink} ${(o == null ? void 0 : o.mainMenuLink) ?? ""} `,
          children: c
        }
      ),
      /* @__PURE__ */ n(S, { className: e.arrowIcon })
    ] }) : null) }),
    a ? N(
      /* @__PURE__ */ t(
        "div",
        {
          className: `${e.areasMenuModal} ${o == null ? void 0 : o.container}`,
          children: [
            /* @__PURE__ */ t("div", { className: e.closeWrapper, children: [
              /* @__PURE__ */ n(
                b,
                {
                  className: `${e.closeButton} ${e.activeIcon} ${f ? e.hidden : ""}`,
                  onClick: s
                }
              ),
              typeof l == "function" ? l(a) : l
            ] }),
            /* @__PURE__ */ t("div", { className: e.modalContent, children: [
              /* @__PURE__ */ n("a", { href: g, className: e.headingContainer, children: /* @__PURE__ */ n("div", { className: `${e.mainMenuLink} ${e.pageTitle}`, children: c }) }),
              /* @__PURE__ */ n("div", { className: e.areasList, children: I.map((i) => {
                const r = /* @__PURE__ */ t(v, { children: [
                  /* @__PURE__ */ t("div", { className: e.menuDropdownItemTitleWrapper, children: [
                    /* @__PURE__ */ n(
                      "div",
                      {
                        className: `${e.menuDropdownItemTitle} ${i.isGradient ? e.gradientText : ""}`,
                        children: i.title
                      }
                    ),
                    i.icon
                  ] }),
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemDescription, children: i.description })
                ] });
                if (i.path)
                  return /* @__PURE__ */ n(
                    "a",
                    {
                      className: `${e.menuDropdownItem} ${(o == null ? void 0 : o.itemRow) ?? ""}`,
                      href: i.path,
                      children: r
                    },
                    i.title
                  );
                if (i.onClick)
                  return /* @__PURE__ */ n(
                    "div",
                    {
                      className: `${e.menuDropdownItem} ${(o == null ? void 0 : o.itemRow) ?? ""}`,
                      onClick: i.onClick,
                      children: r
                    },
                    i.title
                  );
              }) }),
              /* @__PURE__ */ n(T, { className: e.mobileBGIcon })
            ] })
          ]
        }
      ),
      document.body
    ) : null
  ] });
};
export {
  P as DropdownMenuItemDesktop,
  V as DropdownMenuItemMobile
};
